import i18next from 'i18next'
import React from 'react'
import { formatDateTime, formatNumberWithTwoDecimals } from '../../utils/general'
import { renderAreaUnit, renderCurrency, renderCurrencyWithUnit } from '../../utils/property'
import { companyResponseFields } from '../response/company'

export const companyGeneralViewData = (data) => {
    const { t } = i18next

    const companyPhone = data?.[companyResponseFields.CONTACT_PHONE]?.map((item, i) => ({
        id: `${companyResponseFields.CONTACT_PHONE}-${item.id}`,
        label: `${t('view.contact.general.phone')} ${i + 1}`,
        value: `${item.phoneNumber}${item.contactPhoneType ? ' - ' + item.contactPhoneType?.name : ''}`,
    }))

    const companyEmail = data?.[companyResponseFields.CONTACT_EMAIL]?.map((item, i) => ({
        id: `${companyResponseFields.CONTACT_EMAIL}-${item.id}`,
        label: `${t('app.common.email.label')}  ${i + 1}`,
        value: (
            <>
                <a className="dmn-link" href={`mailto:${item.email}`}>
                    {item.email}
                </a>
                {item.contactEmailType ? ' - ' + item.contactEmailType?.name : ''}
            </>
        ),
    }))

    return {
        general: [
            {
                id: companyResponseFields.ID,
                label: t('app.common.id'),
                value: data?.[companyResponseFields.INTERNAL_APP_ID],
            },
            {
                id: `${companyResponseFields.NAME}`,
                label: t('app.common.name'),
                value: `${
                    data?.[companyResponseFields.CONTACT_COMPANY]?.[companyResponseFields.NAME]
                        ? data?.[companyResponseFields.CONTACT_COMPANY]?.[companyResponseFields.NAME]
                        : ''
                }`,
            },
            {
                id: `${companyResponseFields.FULL_NAME}`,
                label: t('app.common.company.fullName'),
                value: `${
                    data?.[companyResponseFields.CONTACT_COMPANY]?.[companyResponseFields.FULL_NAME]
                        ? data?.[companyResponseFields.CONTACT_COMPANY]?.[companyResponseFields.FULL_NAME]
                        : ''
                }`,
            },
            {
                id: `${companyResponseFields.TAX_NUMBER}`,
                label: t('app.common.pin'),
                value: `${data?.[companyResponseFields.TAX_NUMBER] ?? ''}`,
            },

            {
                id: `${companyResponseFields.STREET}-${companyResponseFields.STREET_NUMBER}`,
                label: t('view.contact.general.address'),
                value:
                    (data?.[companyResponseFields.STREET] ||
                        data?.[companyResponseFields.STREET_NUMBER] ||
                        data?.[companyResponseFields.ZIP_CODE] ||
                        data?.[companyResponseFields.CITY] ||
                        data?.[companyResponseFields.CONTACT_COUNTRY]) &&
                    `${data?.[companyResponseFields.STREET] ?? ''} ${data?.[companyResponseFields.STREET_NUMBER] ?? ''} ${
                        data?.[companyResponseFields.ZIP_CODE] ?? ''
                    } ${data?.[companyResponseFields.CITY] ?? ''} ${
                        data?.[companyResponseFields.CONTACT_COUNTRY] ? ', ' + data?.[companyResponseFields.CONTACT_COUNTRY]?.name : ''
                    }`,
            },
            ...(companyPhone ?? []),
            ...(companyEmail ?? []),
            {
                id: companyResponseFields.WEBSITE,
                label: t('app.common.web'),
                value: data?.[companyResponseFields.CONTACT_COMPANY]?.[companyResponseFields.WEBSITE],
            },
            {
                id: companyResponseFields.CONTACT_LEGAL_FORM,
                label: t('app.common.company.legalForm'),
                value: data?.[companyResponseFields.CONTACT_COMPANY]?.[companyResponseFields.CONTACT_LEGAL_FORM]?.name,
            },
            {
                id: companyResponseFields.DATA_SOURCE,
                label: t('app.common.contact.dataSource'),
                value: data?.[companyResponseFields.DATA_SOURCE]?.name,
            },
            {
                id: companyResponseFields.CONTACT_STATUS,
                label: t('app.common.status'),
                value: data?.[companyResponseFields.CONTACT_STATUS] ? data?.[companyResponseFields.CONTACT_STATUS]?.name : '',
            },
            {
                id: `${companyResponseFields.CONTACT_QUERY_CATEGORY}_name`,
                label: t('app.common.contact.queryCategory'),
                value: data?.[companyResponseFields.CONTACT_QUERY_CATEGORY]?.name,
            },
            {
                id: `${companyResponseFields.CONTACT_PRIORITY}_name`,
                label: t('app.common.contact.priority'),
                value: data?.[companyResponseFields.CONTACT_PRIORITY]?.name,
            },
            {
                id: `${companyResponseFields.CONTACT_CORE_BUSINESS}_name`,
                label: t('app.common.company.coreBusiness'),
                value: data?.[companyResponseFields.CONTACT_COMPANY]?.[companyResponseFields.CONTACT_CORE_BUSINESS]?.name,
            },
            {
                id: `${companyResponseFields.CONTACT_COMPANY_SIZE}_name`,
                label: t('app.common.company.size'),
                value: data?.[companyResponseFields.CONTACT_COMPANY]?.[companyResponseFields.CONTACT_COMPANY_SIZE]?.name,
            },
            {
                id: `${companyResponseFields.EMPLOYEES_NO}_name`,
                label: t('app.common.company.employeesNumber'),
                value: data?.[companyResponseFields.CONTACT_COMPANY]?.[companyResponseFields.EMPLOYEES_NO],
            },
            {
                id: `${companyResponseFields.BANK_ACCOUNT_NO}_name`,
                label: t('app.common.company.bankAccount'),
                value: data?.[companyResponseFields.CONTACT_COMPANY]?.[companyResponseFields.BANK_ACCOUNT_NO],
            },
            {
                id: `${companyResponseFields.REGISTRY_COURT}_name`,
                label: t('app.common.company.registryCourt'),
                value: data?.[companyResponseFields.CONTACT_COMPANY]?.[companyResponseFields.REGISTRY_COURT],
            },
            {
                id: `${companyResponseFields.SHARE_CAPITAL}_name`,
                label: t('app.common.company.shareCapital'),
                value: data?.[companyResponseFields.CONTACT_COMPANY]?.[companyResponseFields.SHARE_CAPITAL],
            },
            {
                id: `${companyResponseFields.AGENT}_full_name`,
                label: t('app.common.agent'),
                value: data?.agent
                    ? data?.[companyResponseFields.AGENT] && (
                          <>
                              {data?.[companyResponseFields.AGENT]?.firstName} {data?.[companyResponseFields.AGENT]?.lastName}
                          </>
                      )
                    : '',
            },
            {
                id: companyResponseFields.CREATED,
                label: t('view.common.other.created'),
                value: formatDateTime(data?.[companyResponseFields.CREATED]),
            },
            {
                id: companyResponseFields.UPDATED,
                label: t('app.common.updated'),
                value: formatDateTime(data?.[companyResponseFields.UPDATED]),
            },
        ],
    }
}
